import {svgIconWrapper} from '../svg-icon-wrapper';

import ChatRegularOptions from './chat-regular-options-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ChatRegularOptions {...validProps} />;
}
SvgComponent.iconName = 'chatRegularOptions';

export const ChatRegularOptionsIcon = svgIconWrapper(SvgComponent);
